import { useCallback, useState } from 'react'
import { callContract } from '../contractClient'
import { contracts } from '../../../../shared/features/platform.contracts'
import useVisibilityRefresh from './useVisibilityRefresh'

const POLL_INTERVAL_MS = 30_000

const EMPTY_STATE = {
  state: 'ok',
  counts: { total: 0, healthy: 0, degraded: 0 },
  degraded_summary: [],
  groups: [],
  generated_at: null,
}

export default function useSystemHealth() {
  const [health, setHealth] = useState(EMPTY_STATE)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const refresh = useCallback(async ({ signal } = {}) => {
    try {
      const response = await callContract(contracts.systemHealth, { config: { signal } })
      if (signal?.aborted) return
      setHealth(response.data || EMPTY_STATE)
      setError(null)
    } catch (err) {
      if (signal?.aborted) return
      setError(err.response?.data?.error || err.message || 'Failed to load system health')
    } finally {
      if (!signal?.aborted) setLoading(false)
    }
  }, [])

  const manualRefresh = useVisibilityRefresh({ refresh, intervalMs: POLL_INTERVAL_MS })

  return { health, loading, error, refresh: manualRefresh }
}
